<div>

  @if (!state.includes('a.crm.customer.create') && ('crm.customer.create'|HasPerm)) {
    <a uiSref="a.crm.create" title="Neuer Kunde" class="btn btn-default"
      >
      <span class="fa fa-plus"></span>
    </a>
  }

  @if (state.includes('a.crm.customer.create')) {
    <a uiSref="a.crm.list" title="Zurück" class="btn btn-default">
      <span class="fa fa-reply"></span>
    </a>
  }


  @if (customer && (('crm.customer.edit'|HasPerm) || ('sales.restricted'|HasPerm))) {
    <div class="btn-group" role="group" aria-label="customer"
      >
      @if (state.includes('a.crm.customer')) {
        <a title="Neuer Ansprechpartner" (click)="newContact()" class="btn btn-default"
          >
          Neuer Ansprechpartner
        </a>
      }
      @if (state.includes('a.crm.customer')) {
        <button class="btn btn-default" (click)="activity()">
          Neue Aktivität
        </button>
      }
      @if (state.includes('a.crm.customer')) {
        @if (!customer.date_deleted && ('crm.customer_delete'|HasPerm)) {
          <button class="btn btn-default" (click)="deleteCustomer()">
            Kunde löschen
          </button>
        } @else if (!!customer.date_deleted && ('crm.customer.restore'|HasPerm)) {
          <customer-restore-button label="Kunde wiederherstellen"
                                   [customerId]="customer?.id"
                                   [customerName]="customer?.name"
                                   (restored)="undeleteCustomer()">
          </customer-restore-button>
        }
      }
      @if ((state.includes('a.crm.customer') && lockButton() !== '')) {
        <button class="btn btn-default" (click)="lockCustomer()"
          >
          {{ lockButton() }}
        </button>
      }
      @if (state.includes('a.crm.customer')) {
        <a uiSref="a.crm.customer.document_create" [uiParams]="{id: customer.id}" class="btn btn-default"
          >
          Neues Dokument
        </a>
      }
    </div>
  }

</div>
